import { useCallback } from 'react';
import { useCompanyProfileUploadRequestDataLazyQuery } from '../graphql';
import type { FApolloLinks } from './types';

type PostResponse = {
  data: {
    /** This is the file ID */
    filename: string;
  };
  links: FApolloLinks;
};

/**
 * Cause you know, file + Apollo = FApollo
 *
 * https://apollo-doc.platform.olx.berlin/
 */
export const useFApolloPostRequest = () => {
  const [queryUploadRequestData] = useCompanyProfileUploadRequestDataLazyQuery();

  return useCallback(
    async (file: File) => {
      const { data } = await queryUploadRequestData();
      const { url, token } = data?.CompanyProfile?.uploadRequestData ?? {};

      if (!url) {
        throw new Error('Missing Apollo URL');
      }

      if (!token) {
        throw new Error('Missing Apollo token');
      }

      const req = await fetch(url, {
        method: 'POST',
        body: file,
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': file.type,
        },
      });

      return req.json() as Promise<PostResponse>;
    },
    [queryUploadRequestData],
  );
};
